import { CommonModule } from '@angular/common'
import { Component, OnInit, inject } from '@angular/core'

import { Store } from '@ngrx/store'
import moment from 'moment'
import { DialogModule } from 'primeng/dialog'
import { ImageModule } from 'primeng/image'
import { ProgressBarModule } from 'primeng/progressbar'
import { TooltipModule } from 'primeng/tooltip'

import { AiCoordinatorActions } from '@flowx/designer/modules/new-ai/agents/coordinator/store/coordinator.actions'
import { AiPlan } from '@flowx/designer/modules/new-ai/common/ai.dictionary'
import { FlxAiMarkdownPipe } from '@flowx/designer/modules/new-ai/common/pipes/flx-ai-markdown.pipe'
import { AiActions } from '@flowx/designer/modules/new-ai/store/ai.actions'
import { AiSelectors } from '@flowx/designer/modules/new-ai/store/ai.selectors'

import { FlxLogDateFormatPipe } from '../agent-log/agent-log.component'

@Component({
  selector: 'flx-ai-generated-plans',
  imports: [
    CommonModule,
    DialogModule,
    ImageModule,
    ProgressBarModule,
    TooltipModule,
    FlxLogDateFormatPipe,
    FlxAiMarkdownPipe,
  ],
  templateUrl: './generated-plans.component.html',
  styleUrls: ['./generated-plans.component.scss'],
  standalone: true,
})
export class GeneratedPlansComponent implements OnInit {
  #store = inject(Store)

  currentPlans = this.#store.selectSignal(AiSelectors.currentPlans)
  isAiGenerating = this.#store.selectSignal(AiSelectors.streamingAiResponse)
  describePlan: any | null = null

  ngOnInit(): void {
    this.checkContextDocuments()
  }

  toggleDescription(plan: AiPlan): void {
    if (this.describePlan?.id === plan.id) {
      this.describePlan = null
      return
    } else {
      this.describePlan = plan
    }
  }

  checkContextDocuments(): void {
    this.#store.dispatch(AiCoordinatorActions.getAllPlans())
  }
  usePlan(plan: any): void {
    this.#store.dispatch(AiCoordinatorActions.getPlan({ plan_id: plan.id }))
    this.#store.dispatch(AiActions.setArchivedSidebarVisible({ isArchivedSidebarVisible: false }))
  }

  getColorByStatus(status: string): string {
    switch (status) {
      case 'pending':
        return 'bg-yellow-500'
      case 'completed':
        return 'bg-green-500'
      case 'failed':
        return 'bg-red-500'
      default:
        return 'bg-gray-500'
    }
  }

  getPlanColorByStatus(status: string): string {
    switch (status) {
      case 'draft':
        return 'bg-gray-700'
      case 'completed':
        return 'bg-green-700'
      case 'in progress':
      case 'in_progress':
        return 'bg-yellow-700'
      case 'failed':
        return 'bg-red-700'
      default:
        return 'bg-gray-700'
    }
  }
}
